import React from "react";
import { Skeleton, Card, Row, Col } from "antd";

const LeftSectionSkeleton: React.FC = () => {
  return (
    <div className="left-details-frame">
      <div className="header-wrapper flex flex-col gap-4">
        {/* Breadcrumb */}
        <Skeleton.Input style={{ width: 200, marginBottom: 16 }} active />

        {/* Ticket Header */}
        <div className="ticket-heading-wrapper flex gap-3 items-center">
          <Skeleton.Input style={{ width: 300, height: 32 }} active />
          <Skeleton.Input style={{ width: 100, height: 24 }} active />
        </div>

        {/* Ticket Description */}
        <div className="ticket-description-card mt-4  flex flex-col gap-3">
          <Skeleton.Input style={{ width: 200 }} active />
          <Skeleton paragraph={{ rows: 3 }} active />
          <Skeleton.Input style={{ width: 150, marginTop: 16 }} active />
          <Skeleton paragraph={{ rows: 2 }} active />
        </div>

        {/* Information & Customer Details Cards */}
        <Row gutter={[16, 16]}>
          {[1, 2].map((i) => (
            <Col span={24} key={i}>
              <Card style={{ minHeight: 120 }}>
                <Skeleton.Input
                  style={{ width: 150, marginBottom: 12 }}
                  active
                />
                <Row gutter={[16, 16]}>
                  {[1, 2].map((j) => (
                    <Col span={12} key={j}>
                      <Skeleton paragraph={{ rows: 1 }} active />
                    </Col>
                  ))}
                </Row>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Attachments */}
        <div className="attachments-wrapper mt-6">
          <Skeleton.Input style={{ width: 120 }} active />
          <div className="attachments-list flex gap-3 mt-3">
            {[1, 2, 3, 4].map((i) => (
              <Skeleton.Avatar
                key={i}
                shape="square"
                size={184}
                style={{ width: 184, height: 178 }}
                active
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeftSectionSkeleton;
